import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createMemoryRouter } from 'react-router-dom';
import App from './App';
function MainLib(params) {
    return (_jsxs(_Fragment, { children: [_jsx("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" }), _jsx(App, { routerFactory: createMemoryRouter, params: params })] }));
}
export default MainLib;
